import { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash-es/debounce';
import i18nContext from 'components/i18n-context';
import { COUNTERPARTY_ACTION } from 'components/constants';
import CustomSearchInput from 'components/CustomSearchInput';
import Loader from 'components/Loader';
import Button from 'uikit/Button/Button';
import { InputDropDown } from 'uikit/InputDropDown/InputDropDown';
import './CounterpartiesTableFiltersBar.scss';
import { CheckBox } from '../../../../../../uikit/CheckBox/CheckBox';

const CounterpartiesTableFiltersBar = ({
  isInitialized,
  isLoading,
  filters,
  totalElements,
  handleSetFilters,
  handleExportCounterpartiesList
}) => {
  const i18n = useContext(i18nContext);
  const [searchValue, setSearchValue] = useState(filters.search_text ? filters.search_text : '');

  const debouncedSearch = useRef(
    debounce((name, value) => {
      handleSetFilters(name, value);
    }, 400)
  ).current;

  const handleSearchTextInputChange = ({ target: { name, value } }) => {
    setSearchValue(value);

    debouncedSearch(name, value);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const counterpartiesStatusesOptions = Object.keys(COUNTERPARTY_ACTION).map((key) => {
    return {
      key: COUNTERPARTY_ACTION[key],
      value: i18n.getMessage('counterpartyAction.' + COUNTERPARTY_ACTION[key])
    };
  });

  return (
    <div className={'counterparties-filters-container'}>
      <div className={'counterparties-actions-wrapper'}>
        <div className={'export-counterparties-reports-actions-wrapper'}>
          <Button
            className={'counterparties-button'}
            size={'medium'}
            type={'primary'}
            onClick={handleExportCounterpartiesList}
            isDisabled={!isInitialized || isLoading}
          >
            {isLoading ? <Loader /> : i18n.getMessage('counterparties.button.counterpartiesCsv')}
          </Button>
        </div>
      </div>

      <InputDropDown
        className={'counterparties-filter-wrapper'}
        label={i18n.getMessage('counterparties.filter.action.label')}
        name={'action'}
        value={filters.action}
        options={counterpartiesStatusesOptions}
        onChange={handleSetFilters}
        isMulti
      />
      <CustomSearchInput
        wrapperClassName={'search-wrapper'}
        inputClassName={'counterparties-filter-wrapper'}
        label={i18n.getMessage('counterparties.filter.search.label')}
        placeholder={i18n.getMessage('counterparties.filter.search.placeholder')}
        name={'search_text'}
        value={searchValue}
        onChange={handleSearchTextInputChange}
        totalElements={totalElements}
      />
      <CheckBox
        className={'counterparties-filter-checkbox'}
        name={'show_internal'}
        isActive={filters.show_internal}
        isReverseView={false}
        showCheckBox={true}
        onChange={() => handleSetFilters('show_internal', !filters.show_internal)}
        value={i18n.getMessage('counterparties.filter.showInternal.label')}
        disabled={isLoading}
      />
    </div>
  );
};

CounterpartiesTableFiltersBar.propTypes = {
  isInitialized: PropTypes.bool,
  isLoading: PropTypes.bool,
  filters: PropTypes.object,
  totalElements: PropTypes.number,
  handleSetFilters: PropTypes.func,
  handleExportCounterpartiesList: PropTypes.func
};

export default CounterpartiesTableFiltersBar;
